import React, { useEffect, useState } from "react";

const ScrollHandler = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    const position = window.scrollY;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    // Store the scroll position in local storage
    localStorage.setItem("scrollPosition", scrollPosition.toString());
  }, [scrollPosition]);

  return <>{children}</>;
};

export default ScrollHandler;
